import Vue from 'vue';

Vue.mixin({
  methods: {
    addToRouteQuery(data, method = 'replace') {
      const query = Object.assign({}, this.$route.query);
      const keys = Object.keys(data);
      keys.forEach(key => (query[key] = data[key]));
      this.$router[method]({ query });
    },
    removeFromRouteQuery(fields, method = 'replace') {
      const query = Object.assign({}, this.$route.query);
      fields.forEach(field => delete query[field]);
      this.$router[method]({ query });
    },
  },
});
